/**
 * @author Rahul Nainala
 * @description 
 */
import '../CSS/eLog.css';
// import axios from 'axios';
// import moment from 'moment';
// import FileBase64 from './FileBase64';
import styles from '../CSS/style.less';
// import SelectComponent from './SelectComponent';
// import { deleteFileUpload } from '../eLogCalls';
// import { LOGBOOK } from '../../../../commons/api';
import React, { useEffect, useState } from 'react';
// import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import {
  // Input,
  Button,
  Tooltip,
  message,
  // InputNumber,
  Modal,
  Form,
  Row,
  Anchor,
  // DatePicker
} from 'antd';

const newLocal = true;
const { Link } = Anchor;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

const TableView = (props) => {

  const [form, setForm] = useState(props.form);
  const [columns, setColumns] = useState(props.form && props.form.columns ? props.form.columns : []);
  const [data, setData] = useState(props.form && props.form.datasource ? props.form.datasource : []);
  const [modal, setModal] = useState(props.form && props.form.modal ? props.form.modal : []);
  const [editObject, setEditObject] = useState({});
  const [loading, setLoading] = useState(false);
  const [editIndex, setEditIndex] = useState({});
  // const [mainHeaderValue, setMainHeaderValue] = useState(props.mainHeaderValue ? props.mainHeaderValue : {});
  // const [subHeaderValue, setSubHeaderValue] = useState(props.subHeaderValue ? props.subHeaderValue : {});
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let columns = generateColumns(
      props.form && props.form.columns ? props.form.columns : [],
      props.mainHeaderValue ? props.mainHeaderValue : {},
      props.subHeaderValue ? props.subHeaderValue : {}
    );
    setForm(props.form);
    setColumns(columns);
    setData(props.form && props.form.datasource ? props.form.datasource : []);
    setModal(props.form && props.form.modal ? props.form.modal : []);
  }, []);

  const generateColumns = (columns) => {
    let finalColumns = [];
    let { translationCache } = this.props;
    if (columns && columns.length > 0) {
      finalColumns = columns.map((column) => {
        return {
          title:
            translationCache && translationCache[column.title] && translationCache[column.title]
              ? translationCache[column.title]
              : column.title,
          dataIndex: column.key || 0,
          key: column.key || 0,
          width: column.width,
          widget: column.widget,
          required: column.required,
          table: column.table || {},
          render: (text) => {
            if (Array.isArray(text)) {
              return text.map((file, index) => {
                return (
                  <div key={index}>
                    <Link href={file.url} title={file.name} target="_blank" />
                  </div>
                );
              });
            } else {
              return text;
            }
          }
        };
      });
    }
    return finalColumns;
  };

  // const deleteFile = async (file) => {
  //   if (file && file.response && file.response.name) {
  //     await deleteFileUpload(file.response.name);
  //     message.success('File Deleted');
  //   } else {
  //     message.error('Error deleting file');
  //   }
  // };

  // const onFileChange = (info, column, text, record) => {
  //   if (info.file.status === 'done') {
  //     let fieldValue = [];
  //     if (text && Array.isArray(text) && text !== undefined) {
  //       fieldValue = [...text, info.file.response];
  //     } else if (!text) {
  //       fieldValue = [info.file.response];
  //     }
  //     handleFieldChange(fieldValue, column.key, record.key);
  //     message.success(`${info.file.name} file uploaded successfully`);
  //   } else if (info.file.status === 'error') {
  //     message.error(`${info.file.name} file upload failed.`);
  //   } else if (info.file.status === 'removed') {
  //     deleteFile(info.file);
  //     handleFieldChange(info.fileList, column.key, record.key);
  //   }
  // };

  const saveRow = (e, key, record) => {
    e.persist();
    setLoading(true);
    // if (clickedCancel) {
    //   clickedCancel = false;
    //   return;
    // }
    const target = getRowByKey(key) || {};
    let checkReqField = false;
    columns &&
      Array.isArray(columns) &&
      columns.map((columnsObject) => {
        if (
          columnsObject['required'] &&
          (columnsObject['required'] === 'true' || columnsObject['required'] === true)
        ) {
          if (
            target[columnsObject.key] ||
            (target[columnsObject.key] === 0 &&
              (target[columnsObject.key] !== '' || (record && record.widget === false)))
          ) {
            return {};
          } else {
            e.target.focus();
            checkReqField = true;
          }
        }
        return {};
      });
    if (checkReqField) {
      message.warn('Please fill in the complete information');
    } else {
      saveToggleEditable(e, key);
      setLoading(false);
    }
  };

  // const editRow = (key) => { toggleEditable(key); };

  // const cancel = (e, key) => {
  //   clickedCancel = true;
  //   e.preventDefault();
  //   const newData = data.map((item) => ({ ...item }));
  //   const target = getRowByKey(key, newData);
  //   if (cacheOriginData !== undefined) {
  //     if (cacheOriginData[key]) {
  //       Object.assign(target, cacheOriginData[key]);
  //       delete cacheOriginData[key];
  //     }
  //   }
  //   target.editable = false;
  //   setData(newData);
  //   clickedCancel = false;
  // };

  const getRowByKey = (key, newData) => {
    return (newData || data).filter((item) => item.key === key)[0];
  };

  const saveToggleEditable = (e, key) => {
    e.preventDefault();
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(key, newData);
    if (target) {
      // if (!target.editable && cacheOriginData) {
      //   cacheOriginData[key] = { ...target };
      // }
      target.editable = !target.editable;
      setData(newData);
      props.saveTableViewData(newData);
      //  Save to Backend
    }
  };

  // const toggleEditable = (key) => {
  //   const newData = data.map((item) => ({ ...item }));
  //   const target = getRowByKey(key, newData);
  //   if (target) {
  //     target.editable = !target.editable;
  //     setData(newData);
  //     props.saveTableViewData(newData);
  //   }
  // };

  // const remove = (key) => {
  //   if (key.isNew) {
  //     const newData = data.filter((item) => item.key !== key.key);
  //     setData(newData);
  //     //Delete BAckend Call
  //   } else {
  //     message.error('Cant delete this record..');
  //   }
  // };

  // const handleKeyPress = (e, key) => {
  //   if (e.key === 'Enter') {
  //     saveRow(e, key);
  //   }
  // };

  // const inputNumberChange = (minValue, maxValue, value, key, record) => {
  //   if (
  //     value >= minValue &&
  //     value <= maxValue &&
  //     minValue !== undefined &&
  //     maxValue !== undefined
  //   ) {
  //     handleFieldChange(value, key, record);
  //   } else if (minValue === undefined && maxValue === undefined) {
  //     handleFieldChange(value, key, record);
  //   } else {
  //     handleFieldChange('', key, record);
  //     message.error(`The input range must between ${minValue} and ${maxValue}`);
  //   }
  // };

  // const handleFieldChange = async (fieldValue, fieldName, keyValue) => {
  //   const newData = data.map((item) => ({ ...item }));
  //   const target = getRowByKey(keyValue, newData);
  //   if (fieldName === 'ItemCode') {
  //     let found = newData.some((el) => el.ItemCode === fieldValue);
  //     if (found) {
  //       message.warn('ItemCode Must be Unique');
  //       return;
  //     }
  //   }
  //   if (fieldValue && Array.isArray(fieldValue)) {
  //     fieldValue = fieldValue[fieldValue.length - 1];
  //   }

  //   if (target) {
  //     target[fieldName] = fieldValue;
  //     if (fieldName === 'Quantity' || fieldName === 'M.C %') {
  //       if (
  //         newData[keyValue - 1]['Quantity'] !== undefined &&
  //         newData[keyValue - 1]['M.C %'] !== undefined
  //       ) {
  //         if (newData[keyValue - 1]['Quantity'] !== '' && newData[keyValue - 1]['M.C %'] !== '') {
  //           target['Dry Weight'] = parseFloat(
  //             newData[keyValue - 1]['Quantity'] -
  //             newData[keyValue - 1]['Quantity'] * newData[keyValue - 1]['M.C %']
  //           ).toFixed(3);
  //         }
  //       }
  //     }
  //     if (fieldName === 'ApplicationType') {
  //       const accessToken = localStorage.get('accessToken');
  //       let obj = {
  //         method: 'POST',
  //         url: `${LOGBOOK.DropDown}`,
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`
  //         },
  //         data: {
  //           tableName: 'master."Master_ThermoCoupleNumber"',
  //           columnName: 'Temperature',
  //           condition: 'Number',
  //           conditionvalue: fieldValue
  //         }
  //       };

  //       let data = await axios(obj);

  //       target['Standard_Temp'] = data.data[0];
  //     }
  //     setData(newData);
  //   }
  // };

  // const handleDataChange = (fieldValue, fieldName) => {
  //   const newData = data.map((item) => ({ ...item }));
  //   if (newData) {
  //     newData.map((item, key) => {
  //       newData[key][fieldName] = fieldValue;
  //       return {};
  //     });
  //     setData(newData);
  //   }
  //   props.saveTableViewData(newData);
  // };

  const addRow = () => {
    let newdata = {};
    modal &&
      Array.isArray(modal) &&
      modal.map((columnData) => {
        if (columnData.key === 'Task') {
          let maxTask =
            data && Array.isArray(data) && data.length > 0
              ? Math.max.apply(
                Math,
                data.map(function (o) {
                  return o.Task;
                })
              )
              : 0;
          newdata[columnData.key] = maxTask + 10;
        } else {
          newdata[columnData.key] = '';
        }
        return {};
      });
    // if(){
    newdata = {
      ...newdata,
      AttachmentName: '',
      AttachmentSize: '',
      AttachmentType: '',
      Base64: ''
    };
    // }

    data.push(newdata);
    setData(data);
    props.saveTableViewData(data);
  };

  // const disabledDate = (current) => {
  //   return current > moment().endOf('day');
  // };

  // const renderSwitch = (formObject, columns) => {
  //   const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  //   switch (columns.widget) {
  //     case 'input':
  //       return (
  //         <Input
  //           style={{
  //             width: 300,
  //             ...(props.status === 'Completed'
  //               ? {
  //                 opacity: newLocal ? 0.75 : 1,
  //                 pointerEvents: newLocal ? 'none' : 'initial'
  //               }
  //               : {})
  //           }}
  //           value={editObject && editObject[columns.key] ? editObject[columns.key] : ''}
  //           maxLength={columns && columns.maxLength ? columns.maxLength : 100}
  //           disabled={columns.disabled ? columns.disabled : false}
  //           placeholder={columns.placeHolder}
  //           onChange={(e) => onInputChange(e.target.value, columns.key, columns)}
  //         />
  //       );
  //     case 'select':
  //       return (
  //         <SelectComponent
  //           column={columns}
  //           record={{ key: columns }}
  //           text={editObject && editObject[columns.key] ? editObject[columns.key] : undefined}
  //           datasource={editObject && editObject ? editObject : []}
  //           handleFieldChange={(e) => onInputChange(e, columns.key, columns)}
  //           handleKeyPress={handleKeyPress}
  //           status={props.status}
  //         />
  //       );
  //     case 'inputNumber':
  //       return (
  //         <InputNumber
  //           style={{
  //             width: 300,
  //             ...(props.status === 'Completed'
  //               ? {
  //                 opacity: newLocal ? 0.75 : 1,
  //                 pointerEvents: newLocal ? 'none' : 'initial'
  //               }
  //               : {})
  //           }}
  //           value={
  //             editObject && editObject && (editObject[columns.key] || editObject[columns.key] === 0)
  //               ? editObject[columns.key]
  //               : ''
  //           }
  //           disabled={columns.disabled ? columns.disabled : false}
  //           placeholder={columns.placeHolder}
  //           min={columns.min ? columns.min : 0}
  //           max={columns.max ? columns.max : 1000000}
  //           onChange={(e) => onInputChange(e, columns.key)}
  //         />
  //       );
  //     case 'date-picker':
  //       return (
  //         <DatePicker
  //           disabledDate={disabledDate}
  //           value={
  //             editObject && editObject && editObject[columns.key]
  //               ? moment(editObject[columns.key], dateFormat)
  //               : props.elog &&
  //                 props.elog.logbookID &&
  //                 props.elog.logbookID === 'MC-08 Sorting-Packing Production Logbook'
  //                 ? moment(editObject[columns.key], dateFormat)
  //                 : null
  //           }
  //           format={columns.showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'}
  //           allowClear={false}
  //           showNow={false}
  //           showTime={columns.showTime ? columns.showTime : false}
  //           disabled={columns.disable ? columns.disable : false}
  //           onChange={(e) => onInputChange(e, columns.key, columns)}
  //           style={{
  //             width: 300,
  //             ...(props.status === 'Completed'
  //               ? {
  //                 opacity: newLocal ? 0.75 : 1,
  //                 pointerEvents: newLocal ? 'none' : 'initial'
  //               }
  //               : {})
  //           }}
  //         />
  //       );
  //     case 'date-time picker':
  //       return (
  //         <DatePicker
  //           style={{
  //             width: 300,
  //             ...(props.status === 'Completed'
  //               ? {
  //                 opacity: newLocal ? 0.75 : 1,
  //                 pointerEvents: newLocal ? 'none' : 'initial'
  //               }
  //               : {})
  //           }}
  //           disabled={
  //             columns.key &&
  //               columns.key === 'ActualFinish' &&
  //               editObject &&
  //               !editObject['ActualStart']
  //               ? true
  //               : false
  //           }
  //           allowClear={false}
  //           showTime={columns.showTime ? columns.showTime : false}
  //           onChange={(e) => onInputChange(e, columns.key, columns)}
  //           value={
  //             editObject && editObject && editObject[columns.key]
  //               ? columns.showTime && columns.showTime === true
  //                 ? moment.utc(editObject[columns.key], dateFormat).local()
  //                 : moment.utc(editObject[columns.key], 'YYYY-MM-DD').local()
  //               : props.elog &&
  //                 props.elog.logbookID &&
  //                 props.elog.logbookID === 'MC-08 Sorting-Packing Production Logbook'
  //                 ? moment(editObject[columns.key], 'YYYY-MM-DD HH:mm:ss')
  //                 : null
  //           }
  //           disabledTime={(e) => getDisabledHours(moment.utc(e, dateFormat), columns.key)}
  //           disabledDate={(d) =>
  //             !d ||
  //             d.isAfter(
  //               columns.key === 'ActualStart' && editObject['ActualFinish']
  //                 ? moment(editObject['ActualFinish']).add(1, 'day').format('YYYY-MM-DD')
  //                 : ''
  //             ) ||
  //             d.isBefore(
  //               columns.key === 'ActualFinish' && editObject['ActualStart']
  //                 ? moment(editObject['ActualStart']).format('YYYY-MM-DD')
  //                 : ''
  //             ) ||
  //             d.isAfter(moment().add(1, 'day').format('YYYY-MM-DD'))
  //           }
  //           format={columns.showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'}
  //           onOk={(e) => onMainOk(e, columns.key, columns)}
  //         />
  //       );
  //     case 'timePicker':
  //       return (
  //         <Input
  //           format="HH:mm:ss"
  //           value={
  //             editObject &&
  //               editObject[columns.key] !== '' &&
  //               (editObject[columns.key] || editObject[columns.key] === 0)
  //               ? editObject[columns.key]
  //               : ''
  //           }
  //           style={{
  //             width: 300,
  //             ...(props.status === 'Completed'
  //               ? {
  //                 opacity: newLocal ? 0.75 : 1,
  //                 pointerEvents: newLocal ? 'none' : 'initial'
  //               }
  //               : {})
  //           }}
  //           disabled={columns.disable ? columns.disable : false}
  //           disabledHours={() => getDisabledHours(columns.key)}
  //           onChange={(e, string) => onInputChange(string, columns.key, columns)}
  //         />
  //       );

  //     case 'imageUploadBase64':
  //       return (
  //         <span>
  //           <span
  //             style={{
  //               ...(props.status === 'Completed'
  //                 ? {
  //                   opacity: newLocal ? 0.75 : 1,
  //                   pointerEvents: newLocal ? 'none' : 'initial'
  //                 }
  //                 : {})
  //             }}
  //           >
  //             <FileBase64
  //               id={editObject && editObject.Id ? editObject.Id : editObject}
  //               type="file"
  //               multiple={false}
  //               onDone={(file) => {
  //                 let { editObject } = state;
  //                 if (file && file.type !== 'image/svg+xml') {
  //                   setEditObject({
  //                     ...editObject,
  //                     AttachmentName: file.name,
  //                     AttachmentSize: file.size,
  //                     AttachmentType: file.type,
  //                     Base64: file.base64
  //                   });
  //                 } else {
  //                   message.error('SVG File is not allowed');
  //                 }
  //               }}
  //             />
  //           </span>
  //           {editObject && editObject['AttachmentName'] && editObject.Base64 ? (
  //             <a
  //               href={editObject.Base64}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //             >
  //               {editObject.AttachmentName}
  //             </a>
  //           ) : null}
  //         </span>
  //       );
  //     case 'text':
  //       return <div></div>;
  //     default:
  //       return <div></div>;
  //   }
  // };

  // const onInputChange = (columnValue, columnKey, columns) => {
  //   let EstimatedDuration = null;
  //   if (columns && columns.key === 'EndTime' && editObject['StartTime']) {
  //     let startTime = editObject['StartTime'];
  //     let endTime = columnValue;
  //     EstimatedDuration = moment
  //       .utc(moment(endTime, 'HH:mm:ss').diff(moment(startTime, 'HH:mm:ss')))
  //       .format('HH:mm:ss');
  //   } else if (columns && columns.key === 'StartTime' && editObject['EndTime']) {
  //     let endTime = editObject['EndTime'];
  //     let startTime = columnValue;
  //     EstimatedDuration = moment
  //       .utc(moment(endTime, 'HH:mm:ss').diff(moment(startTime, 'HH:mm:ss')))
  //       .format('HH:mm:ss');
  //   } else if (columnKey && (columnKey === 'ActualStart' || columnKey === 'ActualFinish')) {
  //     columnValue = moment(columnValue).utc().format('YYYY-MM-DD');
  //   }
  //   let editObject = {
  //     ...editObject,
  //     EstimatedDuration: EstimatedDuration ? EstimatedDuration : editObject.EstimatedDuration,
  //     [`${columnKey}`]: columnValue
  //   };
  //   setEditObject(editObject);
  // };

  // const getDisabledHours = (e, key) => {
  //   let hours = [];
  //   let minutes = [];
  //   let ActualStartDateTime = '';
  //   let ActualFinishDateTime = '';

  //   let ActualStartDate = '';
  //   let ActualFinishDate = '';

  //   if (key === 'ActualStart') {
  //     ActualStartDateTime = moment(e).format('YYYY-MM-DD HH:mm');
  //     ActualFinishDateTime = moment
  //       .utc(editObject && editObject.ActualFinish, 'YYYY-MM-DD HH:mm')
  //       .local();

  //     ActualStartDate = moment(e).format('YYYY-MM-DD');
  //     ActualFinishDate = moment
  //       .utc(editObject && editObject.ActualFinish)
  //       .local()
  //       .format('YYYY-MM-DD');
  //   } else if (key === 'ActualFinish') {
  //     ActualStartDateTime = moment
  //       .utc(editObject && editObject.ActualStart, 'YYYY-MM-DD HH:mm')
  //       .local();
  //     ActualFinishDateTime = moment(e).format('YYYY-MM-DD HH:mm');

  //     ActualStartDate = moment
  //       .utc(editObject && editObject.ActualStart)
  //       .local()
  //       .format('YYYY-MM-DD');
  //     ActualFinishDate = moment(e).format('YYYY-MM-DD');
  //   }
  //   if (
  //     key === 'ActualStart' &&
  //     moment(ActualStartDate).isSame(
  //       moment(ActualFinishDate) ||
  //       moment(ActualStartDateTime).hours() === moment(ActualFinishDateTime).hours()
  //     )
  //   ) {
  //     for (var i = 0; i <= 24; i++) {
  //       if (i > moment(ActualFinishDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (moment(ActualStartDate).isSame(moment(ActualFinishDate))) {
  //       for (let i = 0; i <= 60; i++) {
  //         if (i > moment(ActualFinishDateTime).minutes() - 1) {
  //           minutes.push(i);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   } else if (
  //     key === 'ActualFinish' &&
  //     moment(ActualStartDate).isSame(
  //       moment(ActualFinishDate) ||
  //       moment(ActualStartDateTime).hours() === moment(ActualFinishDateTime).hours()
  //     )
  //   ) {
  //     for (let i = 0; i < moment(ActualStartDateTime).hours(); i++) {
  //       if (i < 25) {
  //         hours.push(i);
  //       }
  //     }

  //     if (moment(ActualStartDate).isSame(moment(ActualFinishDate))) {
  //       for (let i = 0; i < moment(ActualStartDateTime).minutes(); i++) {
  //         if (i < 61) {
  //           minutes.push(i);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   }
  // };

  // const onOk = (columnValue, columnKey) => {
  //   let startDate = moment(columnValue[0]).format('YYYY-MM-DD HH:mm:ss');
  //   let endDate = moment(columnValue[1]).format('YYYY-MM-DD HH:mm:ss');
  //   let editObject = {
  //     ...editObject,
  //     [columnKey]: {
  //       startDate,
  //       endDate
  //     }
  //   };
  //   setEditObject(editObject);
  // };

  let { recordType, showAddButton, translationCache, status } = props;
  if (recordType !== 'Approver') {
    let columns = [
      ...columns,
      {
        title:
          translationCache && translationCache['Action'] && translationCache['Action']
            ? translationCache['Action']
            : 'Action',
        key: 'action',
        render: (text, record, index) => {
          if (!!record.editable && loading) {
            return null;
          }
          if (record.editable) {
            if (record.isNew) {
              return (
                <span>
                  <Tooltip placement="top" trigger="hover" title={'Save'}>
                    <Button onClick={(e) => saveRow(e, record.key, record)}>
                      <SaveOutlined type="save" />
                    </Button>
                  </Tooltip>
                </span>
              );
            }
            return (
              <span>
                <Tooltip placement="top" trigger="hover" title={'Save'}>
                  <Button onClick={(e) => saveRow(e, record.key, record)}>
                    <EditOutlined type="save" />
                  </Button>
                </Tooltip>
              </span>
            );
          } else {
            return (
              <span>
                <Tooltip placement="top" trigger="hover" title={'Edit'}>
                  <Button
                    onClick={() => {
                      setVisible(true);
                      setEditObject(record);
                      setEditIndex(index);
                    }
                    }
                  >
                    <EditOutlined type="edit" />
                  </Button>
                </Tooltip>
              </span>
            );
          }
        }
      }
    ];
  }

  return (
    <div className="tableView" style={{ marginTop: '15px' }}>
      <div>
        <StyledTable size="small"
          loading={loading}
          columns={columns}
          dataSource={[...(data ? data : [])]}
          pagination={true}
          style={{ marginTop: '10px', border: '1px solid red !important' }}
          rowClassName={(record) => (record.editable ? styles.editable : '')}
        />
        {showAddButton ? (
          <Button
            type="primary"
            style={{
              marginTop: '10px',
              ...(status === 'Completed'
                ? {
                  opacity: newLocal ? 0.75 : 1,
                  pointerEvents: newLocal ? 'none' : 'initial'
                }
                : {})
            }}
            onClick={addRow}
          >
            {translationCache && translationCache['Add Row'] && translationCache['Add Row']
              ? translationCache['Add Row']
              : 'Add Row'}
          </Button>
        ) : null}
      </div>

      <Modal
        title="Update"
        open={visible}
        width={1200}
        onOk={() => {
          let { form } = props;
          let saveObject = [...form.datasource];
          saveObject[editIndex] = editObject;
          props.saveTableViewData(saveObject);
          setVisible(false);
          setEditObject({});
        }}
        onCancel={() => {
          {
            setVisible(false);
            setEditObject({});
          }
        }}
      >
        <Form {...formItemLayout}>
          {form &&
            form.modal &&
            form.modal.map((modalForm, index) => {
              return (
                <Form.Item
                  key={index}
                  required={false}
                  label={
                    translationCache && translationCache[modalForm.displayName]
                      ? translationCache[modalForm.displayName]
                      : modalForm.displayName
                  }
                >
                  <Row>{this.renderSwitch(form, modalForm)}</Row>
                </Form.Item>
              );
            })}
          {/* </Row> */}
        </Form>
      </Modal>
    </div>
  );
};

export default TableView;
